import React from 'react';
import { FormattedMessage } from 'react-intl';
import moment from 'moment-timezone';
import { Campaigns } from '../components/LeadScoring/LeadScoringAttributeTypeSelector/Attributes';

export const initialFilter = {
  'company.is_isp': 0,
  'company.is_hidden': 0,
};

export const defaultFilterState = {
  isFilterDefault: true,
  countries: [],
  companyVisibility: 'VISIBLE',
  dateRange: [
    moment().subtract(120, 'day'),
    moment(),
  ],
};

export const defaultFiltersConfig = {
  allScores: [
    {
      label: <FormattedMessage id="Component.LeadsVisitsFilter.ScoringAll" />,
      value: 'ALL',
    },
    {
      label: <FormattedMessage id="Component.LeadsVisitsFilter.ScoringNoScore" />,
      value: '[null]',
    },
    {
      label: 10,
      value: 10,
    },
    {
      label: 9,
      value: 9,
    },
    {
      label: 8,
      value: 8,
    },
    {
      label: 7,
      value: 7,
    },
    {
      label: 6,
      value: 6,
    },
    {
      label: 5,
      value: 5,
    },
    {
      label: 4,
      value: 4,
    },
    {
      label: 3,
      value: 3,
    },
    {
      label: 2,
      value: 2,
    },
    {
      label: 1,
      value: 1,
    },
    {
      label: 0,
      value: 0,
    },
  ],
  allSources: [
    {
      id: Campaigns.campaign,
      label: <FormattedMessage id="Visit.Source.ValueLabel.campaign" />,
    },
    {
      id: Campaigns.direct,
      label: <FormattedMessage id="Visit.Source.ValueLabel.direct" />,
    },
    {
      id: Campaigns.search,
      label: <FormattedMessage id="Visit.Source.ValueLabel.search" />,
    },
    {
      id: Campaigns.social,
      label: <FormattedMessage id="Visit.Source.ValueLabel.social" />,
    },
    {
      id: Campaigns.website,
      label: <FormattedMessage id="Visit.Source.ValueLabel.website" />,
    },
  ],
  allScoringProfileTypes: [
    { value: 'ALL', label: <FormattedMessage id="Component.LeadsVisitsFilter.ScoringProfilesAll" /> },
    { value: 'PRIVATE', label: <FormattedMessage id="Component.LeadsVisitsFilter.ScoringProfilesPrivate" /> },
    { value: 'PUBLIC', label: <FormattedMessage id="Component.LeadsVisitsFilter.ScoringProfilesPublic" /> },
  ],
  allCompanyVisibilityFilters: [
    { value: 'VISIBLE', label: <FormattedMessage id="Component.LeadsVisitsFilter.CompanyVisibility.Visible" /> },
    { value: 'HIDDEN', label: <FormattedMessage id="Component.LeadsVisitsFilter.CompanyVisibility.Hidden" /> },
    { value: 'ALL', label: <FormattedMessage id="Component.LeadsVisitsFilter.CompanyVisibility.All" /> },
    { value: 'FILTERED', label: <FormattedMessage id="Component.LeadsVisitsFilter.CompanyVisibility.Filtered" /> },
  ],
  hubspotTaskFilters: [
    { value: 'ALL', label: <FormattedMessage id="Component.LeadsVisitsFilter.HubspotTask.ValueAll" /> },
    { value: 'HAS_HUBSPOT_TRANSFER', label: <FormattedMessage id="Component.LeadsVisitsFilter.HubspotTask.ValueHasTask" /> },
    { value: 'NO_HUBSPOT_TRANSFER', label: <FormattedMessage id="Component.LeadsVisitsFilter.HubspotTask.ValueNoTask" /> },
    { value: 'PENDING', label: <FormattedMessage id="Component.LeadsVisitsFilter.HubspotTask.Pending" /> },
  ],
};

export default defaultFiltersConfig;



// WEBPACK FOOTER //
// ./src/utils/dataFilter.js